import { CommonResourceKey } from '@shared/models/ResourceKeys';
import { IControlDescription } from '@shared/models/profiles/ControlDescription';

// tilt = angle change
export const ExpressionHeadTiltLeft = 'head_tilt_left';
export const ExpressionHeadTiltRight = 'head_tilt_right';
export const ExpressionHeadTiltBack = 'head_tilt_back';
export const ExpressionHeadTiltForward = 'head_tilt_forward';
export const ExpressionHeadTurnLeft = 'head_turn_left';
export const ExpressionHeadTurnRight = 'head_turn_right';

// lean = position change
export const ExpressionHeadLeanLeft = 'head_lean_left';
export const ExpressionHeadLeanRight = 'head_lean_right';
export const ExpressionHeadLeanBack = 'head_lean_back';
export const ExpressionHeadLeanForward = 'head_lean_forward';
export const ExpressionHeadMoveUp = 'head_move_up';
export const ExpressionHeadMoveDown = 'head_move_down';
export const ExpressionHeadCenter = 'head_center';

export const HeadControls = [
    ExpressionHeadTiltLeft,
    ExpressionHeadTiltRight,
    ExpressionHeadTiltBack,
    ExpressionHeadTiltForward,
    ExpressionHeadTurnLeft,
    ExpressionHeadTurnRight,
    ExpressionHeadLeanLeft,
    ExpressionHeadLeanRight,
    ExpressionHeadLeanBack,
    ExpressionHeadLeanForward,
    ExpressionHeadMoveDown,
    ExpressionHeadMoveUp,
    ExpressionHeadCenter,
];

const createHeadCommand = (
    value: string,
    title: CommonResourceKey,
    description: CommonResourceKey
): IControlDescription => {
    return {
        value,
        title,
        description,
    };
};

export const HeadControlDescription = [
    createHeadCommand(ExpressionHeadTiltLeft, 'common:head.tilt.left.title', 'common:head.tilt.left.description'),
    createHeadCommand(ExpressionHeadTiltRight, 'common:head.tilt.right.title', 'common:head.tilt.right.description'),
    createHeadCommand(ExpressionHeadTiltBack, 'common:head.tilt.back.title', 'common:head.tilt.back.description'),
    createHeadCommand(
        ExpressionHeadTiltForward,
        'common:head.tilt.forward.title',
        'common:head.tilt.forward.description'
    ),
    createHeadCommand(ExpressionHeadTurnLeft, 'common:head.turn.left.title', 'common:head.turn.left.description'),
    createHeadCommand(ExpressionHeadTurnRight, 'common:head.turn.right.title', 'common:head.turn.right.description'),
    createHeadCommand(ExpressionHeadLeanBack, 'common:head.lean.back.title', 'common:head.lean.back.description'),
    createHeadCommand(
        ExpressionHeadLeanForward,
        'common:head.lean.forward.title',
        'common:head.lean.forward.description'
    ),
    createHeadCommand(ExpressionHeadLeanLeft, 'common:head.lean.left.title', 'common:head.lean.left.description'),
    createHeadCommand(ExpressionHeadLeanRight, 'common:head.lean.right.title', 'common:head.lean.right.description'),
    createHeadCommand(ExpressionHeadMoveUp, 'common:head.lean.up.title', 'common:head.lean.up.description'),
    createHeadCommand(ExpressionHeadMoveDown, 'common:head.lean.down.title', 'common:head.lean.down.description'),
    createHeadCommand(ExpressionHeadCenter, 'common:head.lean.center.title', 'common:head.lean.center.description'),
];
